// Vue
import { Vue, Component, Prop, Inject } from "vue-property-decorator";

// Template
import template from "./template.vue";

// Base Module
import ModuleBase from "#/common/ModuleBase";

// Components
import ModuleWrapper from "#/components/module_wrapper/ModuleWrapper";
import { Headline } from "#/components/headline/Headline";

@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
    Headline,
  },
})
export class ImageSitemapModule extends ModuleBase {
  private btnMap: any = {
    ["wb-e-btn-1"]: "primary",
    ["wb-e-btn-2"]: "default",
    ["wb-e-btn-3"]: "inverted",
    ["button_outline"]: "outline-secondary",
  };

  @Prop({ default: "ErrorWidget" })
  public type!: string;

  public sectionHasButton(section) {
    if (section.hasOwnProperty("button")) {
      if (section["button"]["buttonText"] && section["button"]["buttonLink"]) {
        return true;
      }
    }
    return false;
  }

  public getBackgroundColorFromInstance(instance: object) {
    return instance.hasOwnProperty("color") && instance["color"] !== ""
      ? instance["color"]
      : "black";
  }

  get linkTheme() {
    return this.getBackgroundColorFromInstance(this.instance) === "black"
      ? "secondary"
      : "default";
  }

  public onSelectLink(href) {
    window.open(href);
  }
}
